import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/copyright': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 456c110.5 0 200-89.5 200-200 0-110.5-89.5-200-200-200-110.5 0-200 89.5-200 200 0 110.5 89.5 200 200 200zM363.4 354.9c-9.6 9.7-45.5 41.4-104.1 41.4-82.4 0-140.5-61.4-140.5-141.6 0-79.2 60.3-139.4 139.8-139.4 55.5 0 88.7 26.6 97.6 34.8 2.1 2 3.9 5.9 3.9 8.8 0 2-0.9 4.9-1.9 6.5l-18.2 28.1c-3.8 6-12 7.3-17.5 2.9-8.6-6.8-31.8-22.5-61.7-22.5-48.3 0-77.9 35.3-77.9 80.1 0 41.6 26.9 83.7 78.3 83.7 32.7 0 56.8-19 65.7-27.2 5.3-4.9 13.6-4 17.8 1.7l19.9 27.2c1.3 1.7 2.3 4.9 2.3 7.1 0 2.7-1.6 6.5-3.5 8.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/copyright.js
// module id = 1721
// module chunks = 0